module.exports = __webpack_public_path__ + "static/media/faith-in-god.40526292.jpg";